import { Component, Input } from '@angular/core';
import { BrowserService } from 'src/app/core/browser.service';
import { LeafletHelper } from './leaflet.helper';

const iconRetinaUrl = 'assets/marker-icon-2x.png';
const iconUrl = 'assets/marker-icon.png';
const shadowUrl = 'assets/marker-shadow.png';
@Component({
    selector: 'app-map',
    templateUrl: './map.component.html',
    styleUrl: './map.component.scss',
})
export class MapComponent {
  private map!: L.Map;
  @Input() latitude!: number;
  @Input() longitute!: number;

  constructor(
    private readonly leafletHelper: LeafletHelper,
    private readonly _browserService: BrowserService) {}

  async ngOnInit(){
    if (this._browserService.isBrowserPlatform()) {
      const leafletModule = await import('leaflet');
      const L = leafletModule.default;
      const map = L.map('map').setView([51.505, -0.09], 13);
      L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png').addTo(map);
    }
  }

  async ngAfterViewInit() {
    if(this._browserService.isBrowserPlatform()){
      this.leafletHelper.loadLeaflet().then((L) => {
        this.initMap(L);
        const map = L.map('map').setView([51.505, -0.09], 13);
        L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png').addTo(map);
        this.initMap(L);
      })
    }
  }

  private async initMap(L: any) {
    if(this._browserService.isBrowserPlatform()){
      const iconDefault = L.icon({
        iconRetinaUrl,
        iconUrl,
        shadowUrl,
        iconSize: [25, 41],
        iconAnchor: [12, 41],
        popupAnchor: [1, -34],
        tooltipAnchor: [16, -28],
        shadowSize: [41, 41],
      });
      L.Marker.prototype.options.icon = iconDefault;
      this.map = L.map('map', {
        attributionControl: false,
        center: [this.latitude, this.longitute],
        zoom: 10,
      });

      const tiles = L.tileLayer(
        'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
        {
          maxZoom: 18,
          minZoom: 3,
          // attribution: '<a href="">OpenStreetMap</a>'
        },
      );

      tiles.addTo(this.map);
      this.addMarker(L,this.map, this.longitute, this.latitude);
    }
  }

  addMarker(L: any ,map: L.Map, logitude: number, latitude: number): void {
    const lon = logitude;
    const lat = latitude;
    const marker = L.marker([lat, lon]);

    marker.addTo(map);
  }
}
